import { pageInit } from './plugin'

export function useFile() {
    return {
        download: pageInit.fileDownload,
        preview: pageInit.filePreview,
        fileInfo: pageInit.fileInfo,
        upload: pageInit.fileUploader,
    }
}
